import Documents from '../../../components/Common/Documents/DocumentsCont'
import ProductLinesCont from '../../../components/Main/Product/Lines/ProductLinesCont'
import Product from '../../../components/Main/Product/Product'
import ProductForm from '../../../components/Main/Product/ProductForm'
import Auth from '../../../modules/Authentication'
import { strVal } from '../../../modules/Utils'
import React, { Fragment } from 'react'
import { Avatar, Col, Icon, Modal, Popconfirm, Row, Tabs, Tooltip } from 'antd'
import FooterButtons from '../../../elements/Buttons/FooterButtons'
import style from '../../../components/Sales/style.css'
import CustomSpin from '../../../elements/CustomSpin'
import { get } from 'lodash'
import Status from '../../../elements/Status'
import { streamUrl } from '../../../variables'

const { TabPane } = Tabs

function ProductModal (props) {
  const {
    visible,
    submitting,
    submit,
    update,
    formRef,
    onCancel,
    removing,
    remove,
    product,
    handleActions,
    fetchingActions,
    actions,
    defaultTab,
    isUpdatable,
    isRemovable,
    isNew,
  } = props
  const Operations = props => {
    const ops = actions
      .filter(a => a.key !== 'update' && a.key !== 'remove')
      .map(a => (
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to ${a.value}?`}
            onConfirm={() => handleActions(a.key)}
            okText="Yes"
            cancelText="No">
            <a>{a.value}</a>
          </Popconfirm>
        </span>
      ))
    if (ops.length > 0 && product.status === 'Confirmed') {
      ops.push(
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure you want to  Duplicate this Product?`}
            onConfirm={() => handleActions('duplicate')}
            okText="Yes"
            cancelText="No">
            <a>Duplicate</a>
          </Popconfirm>
        </span>,
      )
    }

    return (
      <div {...props}>
        {ops.length > 0
          ? ops.reduce((prev, curr) => [prev, <span className="ant-divider"/>, curr])
          : []}
      </div>
    )
  }

  const auth = new Auth()
  const imageUrl = `${streamUrl}${get(
    product,
    'image',
  )}?action=view&access_token=${auth.getAccessToken()}`
  return (
    <Modal
      visible={visible}
      title={'Product'}
      onCancel={onCancel}
      destroyOnClose={true}
      width={'85%'}
      footer={
        <FooterButtons
          visible={isUpdatable}
          removing={removing}
          submit={submit}
          update={update}
          submitting={submitting}
          title={'Product'}
          isNew={isNew}
          isEdit={!isNew}
          remove={remove}
          isRemovable={isRemovable}
        />
      }>
      <CustomSpin spinning={fetchingActions}>
        <h3 className={style.title}>
          {!isNew && (
            <Fragment>
              <Row>
                <Col span={6} style={{ textAlign: 'center', marginRight: 40 }}>
                  <Avatar shape="square" style={{ width: 200, height: 200 }} src={imageUrl}/>
                  <br/>
                  <span style={{ marginLeft: 5 }}>ID: {product._key}</span>
                </Col>
                <Col style={{ paddingTop: '20px' }}>
                  <h3 className={style.title}>
                    <h2 className={'icon-text-header'}>
                      <Icon
                        type="barcode"
                        style={{
                          marginRight: '5px',
                          color: '#08c',
                        }}
                      />
                      <Tooltip title="Product Code">{strVal(product, 'code')}</Tooltip>
                    </h2>
                    <Status value={strVal(product, 'status')}/>
                    <Operations
                      style={{ marginTop: '10px' }}
                      product={product}
                      status={strVal(product, 'status')}
                    />
                  </h3>
                </Col>
              </Row>
            </Fragment>
          )}
        </h3>
      </CustomSpin>
      <Tabs defaultActiveKey={defaultTab}>
        <TabPane tab="Details" key="form">
          <Row>
            <ProductForm ref={formRef} {...props} />
          </Row>
        </TabPane>
        <TabPane disabled={isNew} tab={'SKUs'} key="#lines">
          <ProductLinesCont isUpdatable={true} isRemovable={isRemovable} product={product}/>
        </TabPane>
        <TabPane disabled={isNew} tab="Files" key="files">
          <Documents editable={true} footer={false} category={false} owner={product}/>
        </TabPane>
      </Tabs>
    </Modal>
  )
}

ProductModal.propTypes = {}
ProductModal.defaultProps = {
  actions: [],
  defaultTab: 'form',
  fetchingActions: false,
}

export default ProductModal
